export const NoiseOverlay = () => <div className="noise-overlay" aria-hidden="true" />;
